import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { ReactNode, createContext, useState, useRef } from "react";
import success_checknark from "assets/success_checkmark.gif";
import DialogTitle from "@mui/material/DialogTitle";

export type DialogParams = {
    icon?: undefined | 'success';
    title?: undefined | string;
    message?: string;
    dismissText?: undefined | string;
    onDismiss?: () => void;
};

interface IFeedbackDialogContext {
    showFeedbackDialog: (params: DialogParams) => void;
}

interface PropTypes {
    children: ReactNode;
}

const FeedbackDialogContext = createContext<IFeedbackDialogContext>({
    showFeedbackDialog: () => { },
});

function FeedbackDialogProvider({ children }: PropTypes) {
    const [open, setOpen] = useState<boolean>(false);
    const [dialogParams, setDialogParams] = useState<undefined | DialogParams>(undefined);
    const hasPlayedGif = useRef(false);

    const handleClose = () => {
        setOpen(false); // close the dialog
        if (dialogParams?.onDismiss) {
            dialogParams.onDismiss();
        }
    };

    const showFeedbackDialog = (params: DialogParams) => {
        hasPlayedGif.current = false;
        setDialogParams(params);
        setOpen(true);
    };


    return (
        <FeedbackDialogContext.Provider value={{ showFeedbackDialog }}>
            <Dialog
                open={open}
                onClose={handleClose}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    {dialogParams?.icon && (
                        <img
                            ref={(instance) => {
                                if (!hasPlayedGif.current) {
                                    instance?.setAttribute('src', success_checknark);
                                    hasPlayedGif.current = true;
                                }
                            }}
                            alt="Success"
                            width="25%"
                        />
                    )}
                    <DialogTitle variant="h4" align="center">{dialogParams?.title}</DialogTitle>
                </Box>
                {dialogParams?.message && (
                    <DialogContent>
                        <DialogContentText align="center" variant="h6">
                            {dialogParams?.message}
                        </DialogContentText>
                    </DialogContent>
                )}
                <DialogActions>
                    <Button onClick={handleClose}>{!dialogParams?.dismissText ? 'Dismiss' : dialogParams?.dismissText}</Button>
                </DialogActions>
            </Dialog>
            {children}
        </FeedbackDialogContext.Provider>
    );
}

export { FeedbackDialogContext, FeedbackDialogProvider };